/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './modal/Modal';
import { Button, ActionButtonSpinner, getActionButtonLoadingClassName } from '../shared/ui';
import styles from './StopChargingConfirmModal.module.css';

export default function StopChargingConfirmModal({ modalOpen, setModalOpen, onConfirm, isLoading = false }) {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isLoading) {
      setModalOpen(false);
    }
  };

  return (
    <Modal modalOpen={modalOpen} setModalOpen={handleClose}>
      <div className={styles.container}>
        <h2 className={styles.title}>{t('stopChargingConfirm.title')}</h2>
        <p className={styles.message}>{t('stopChargingConfirm.message')}</p>
        <div className={styles.actions}>
          <Button
            type="button"
            variant="outline-simple"
            className={styles.actionBtn}
            onClick={handleClose}
            disabled={isLoading}
          >
            {t('stopChargingConfirm.cancel')}
          </Button>
          <Button
            type="button"
            className={`${styles.actionBtn} ${getActionButtonLoadingClassName(isLoading)}`}
            onClick={onConfirm}
            disabled={isLoading}
            aria-busy={isLoading}
          >
            {isLoading ? <ActionButtonSpinner /> : t('stopButton')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
